import { useContext } from 'react'
import AttachmentContext from '../context/AttachmentProvider';

const useAttachments = () => {
    return useContext(AttachmentContext);
}

export default useAttachments